'use client';

import { CalendarIcon } from './ChannelIcons';

const pillars = [
  {
    key: 'digest',
    title: 'The digest',
    accent: '#3B82F6',
    body: 'Owners get the summary: blockers, commitments, trends — without holding a single meeting.',
  },
  {
    key: 'feed',
    title: 'The feed',
    accent: '#10B981',
    body: 'Everyone finds what they need: answers, decisions, and who said what, searchable across every check-in.',
  },
  {
    key: 'studio',
    title: 'Every check-in is already content.',
    accent: '#F59E0B',
    body: 'Tessa records the call. The studio turns it into moments, captions, and clips your team actually shares.',
  },
];

export default function AfterTheCallSection() {
  return (
    <section className="py-20 bg-card border-t border-b border-border">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">After the call</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] mb-3.5 text-foreground">
            The call ends. The value doesn&rsquo;t.
          </h2>
          <p className="text-[17px] text-muted-foreground max-w-[540px] mx-auto">
            Every check-in becomes searchable knowledge — and Tessa notices who should be talking
            to whom.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar) => (
            <div
              key={pillar.key}
              className="bg-background border border-border rounded-[16px] p-7 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="flex items-center gap-2.5 mb-3">
                <span
                  className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                  style={{ background: pillar.accent }}
                />
                <h3 className="text-[19px] font-bold tracking-[-0.3px] text-foreground">
                  {pillar.title}
                </h3>
              </div>
              <p className="text-[14px] text-muted-foreground leading-[1.7]">{pillar.body}</p>
            </div>
          ))}

          {/* The connector — illustrative Tessa quote bubble */}
          <div className="bg-background border border-border rounded-[16px] p-7 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md">
            <div className="flex items-center gap-2.5 mb-3">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0 bg-[#8B5CF6]" />
              <h3 className="text-[19px] font-bold tracking-[-0.3px] text-foreground">
                The connector
              </h3>
            </div>
            <div className="flex items-start gap-2.5 bg-muted/50 border border-border rounded-2xl rounded-tl-sm p-4 mb-3">
              <div className="relative w-6 h-6 rounded-full overflow-hidden flex-shrink-0 mt-0.5">
                <div
                  className="absolute -inset-0.5"
                  style={{
                    background: 'conic-gradient(from 0deg, #EF4444, #8B5CF6, #3B82F6, #EF4444)',
                    filter: 'blur(2px)',
                  }}
                />
              </div>
              <p className="text-[13px] text-foreground leading-[1.6]">
                &ldquo;This would help George — you two should connect. He&rsquo;s dealing with
                the same problem.&rdquo;
              </p>
            </div>
            <p className="text-[14px] text-muted-foreground leading-[1.7]">
              Tessa proposes the intro, both people say yes, and she books it into both calendars.
            </p>
          </div>
        </div>

        {/* Calendar member benefit */}
        <div className="mt-10 flex items-center justify-center gap-2.5 text-center">
          <span
            className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: '#FEFCE8', color: '#EAB308' }}
          >
            <CalendarIcon className="w-4 h-4" />
          </span>
          <p className="text-[14px] text-muted-foreground">
            Tessa books follow-ups straight into both calendars — nobody chases a time.
          </p>
        </div>
      </div>
    </section>
  );
}
